import React, { useState } from 'react';
import { Mail, ArrowLeft, KeyRound } from 'lucide-react';
import { requestPasswordReset } from '../api/studentApi';
import './ForgotPassword.css';

const ForgotPassword = ({ onBackToLogin }) => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return setError('Please enter your email address.');

        setError('');
        setIsLoading(true);

        try {
            await requestPasswordReset(email);
            setIsSubmitted(true);
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleResend = () => {
        // Re-trigger your submission logic here
        setIsLoading(false);
        setIsSubmitted(false);
        handleSubmit({ preventDefault: () => { } });
    };

    const handleChangeEmail = () => {
        setIsSubmitted(false);
        setEmail('');
        setIsLoading(false);
    };

    return (
        <div className="auth-card">
            {/* Back to Login Arrow Trigger */}
            <button className="back-link-btn" onClick={onBackToLogin}>
                <ArrowLeft size={16} />
                <span>Back to Login</span>
            </button>

            {!isSubmitted ? (
                <>
                    <div className="auth-header">
                        <div className="icon-wrapper">
                            <KeyRound size={28} className="auth-icon" />
                        </div>
                        <h2>Forgot Password?</h2>
                        <p className="auth-subtitle">
                            Enter your username or Email and we'll send you a link to reset your password.
                        </p>
                    </div>

                    <form onSubmit={handleSubmit} className="auth-form">
                        {error && <div className="error-message">{error}</div>}

                        <div className="input-group">
                            <label htmlFor="email">Username or Email</label>
                            <div className="input-field-wrapper">
                                <Mail size={18} className="input-icon" />
                                <input
                                    id="email"
                                    placeholder="Username or email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={isLoading}
                                    required
                                />
                            </div>
                        </div>

                        <button type="submit" className="btn primary-btns" disabled={isLoading}>
                            {isLoading ? 'Sending Link...' : 'Send Reset Link'}
                        </button>
                    </form>
                </>
            ) : (
                /* Success State View */
                <div className="auth-header success-state">
                    <div className="icon-wrapper success animate-bounce-subtle">
                        <Mail size={28} className="auth-icon" />
                    </div>
                    <h2>Check your email</h2>
                    <p className="auth-subtitle">
                        We have sent a password reset link to the email associated with <strong>{email}</strong>.
                        Please check your inbox and click the link to continue.
                    </p>
                    <div className="success-actions-wrapper">
                        <div className="success-actions">
                            <span className="resend-text">Didn't receive the email?</span>
                            <button className="link-button" onClick={handleResend}>
                                Click here to resend
                            </button>
                        </div>
                        <div className="success-actions">
                            <span className="resend-text">Wrong email?</span>
                            <button className="link-button" onClick={handleChangeEmail}>
                                Click here to change
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ForgotPassword;